import React from 'react';

export const EsgContext = React.createContext();

export const useEsgContext = () => {
    const context = React.useContext(EsgContext);
    if (context === undefined) {
        throw new Error(
            "useEsgContext must be used within a EsgContext.Provider"
        );
    }
    return context;
};


export const EsgContextProvider = ({ children }) => {
    const value = useEsgContext();
    return <EsgContext.Provider value={value}>{children}</EsgContext.Provider>;
}
